"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATEADD = void 0;
exports.DATEADD = {
    alias: 'ADICIONAR_DATA',
    description: 'Adiciona a {quantidade} no valor da coluna de {intervalo}',
    arg_names: ['data', 'intervalo', 'quantidade'],
    args_description: [
        'data a ser incrementada',
        'enumerador indicando qual intervalo deve ser incrementada',
        'quantidade a incrementar',
    ],
    target_date_format: 'dd/MM/yyyy',
    source_date_format: 'yyyy-MM-dd',
    replacements: [
        null,
        {
            MONTH: 'MES',
            DAY: 'DIA',
            YEAR: 'ANO',
            MINUTE: 'MINUTO',
            SECOND: 'SEGUNDO',
            HOUR: 'HORA',
        },
        null,
    ],
};
